<template>
  <div class="tab-bar" v-show="showTabBar">
    <div class="item-tab" @click.stop="switchTabHandler(0)">
      <img class="icon" :src="status === 0 ? require('@/assets/images/components/tab/icon_home_select.png') : require('@/assets/images/components/tab/icon_home.png')" alt="">
      <span class="tab-name" :class="{'name-select':status === 0}">案例</span>
    </div>
    <div class="item-tab" @click.stop="switchTabHandler(1)">
      <img class="icon" :src="status === 1 ? require('@/assets/images/components/tab/icon_rise_select.png') : require('@/assets/images/components/tab/icon_rise.png')" alt="">
      <span class="tab-name" :class="{'name-select':status === 1}">增长裂变咨询</span>
    </div>
    <div class="item-tab" @click.stop="switchTabHandler(2)">
      <img class="icon" :src="status === 2 ? require('@/assets/images/components/tab/icon_recommend_select.png') : require('@/assets/images/components/tab/icon_recommend.png')" alt="">
      <span class="tab-name" :class="{'name-select':status === 2}">推荐方案</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  data: function () {
    return {
      showTabBar: true,
      status: 0
    }
  },
  // 监听器
  watch: {
    // 方法1
    $route (to, from) { // 监听路由是否变化
      this.changeStatus()
    }
  },
  created () {
    this.changeStatus()
  },
  methods: {
    changeStatus () {
      const path = this.$route.path.toLowerCase()
      if (path === '/') {
        this.showTabBar = true
        this.status = 0
      } else if (path === '/growth') {
        this.showTabBar = false
        this.status = 1
      }
    },
    switchTabHandler (status) {
      if (status === this.status) {
        return
      }
      if (status === 0) {
        // this.status = 0
        this.$router.push({ path: '/' })
      } else if (status === 1) {
        // this.status = 1
        this.$router.push({ path: '/growth' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.tab-bar {
  width: 100%;
  height: 98px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-top: 2px solid #EEEEEE;
  box-sizing: border-box;
  .item-tab {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
      width: 50px;
      height: 50px;
      margin-bottom: 2px;
    }
    .tab-name {
      font-size: 20px;
      color: #AAAAAA;
      line-height: 28px;
      font-weight: 400;
    }
    .name-select {
      color: #FF6845;
    }
  }
}
</style>
